import React from 'react';
import {Routes} from 'react-router-dom';
import type {AppRouteConfig} from './route.types';
import NotFound from '../pages/notFound';
import {authRoutes} from './auth.route';
import {renderRoutes} from '../components/RenderRoutes';
import {shoppingBasketRoutes} from './shoppingBasket.routes';
import {receiveCreditRoutes} from './receiveCredit.routes';
import {receiveLoanRoutes} from './receiveLoan.routes';
import {farmShopRoutes} from './farmShop.route';
import {messageRoutes} from './message.routes';
import {profileRoutes} from './profile.routes';
import {storeRoutes} from './store.routes';
import {labRoutes} from './lab.routes';

const appRoutes: AppRouteConfig[] = [
  ...authRoutes,
  ...farmShopRoutes,
  ...shoppingBasketRoutes,
  ...receiveCreditRoutes,
  ...receiveLoanRoutes,
  ...messageRoutes,
  ...profileRoutes,
  ...storeRoutes,
  ...labRoutes,
  {path: '*', element: NotFound},
];

const AppRouter = () => <Routes>{renderRoutes(appRoutes)}</Routes>;

export default React.memo(AppRouter);
